import { engine } from "../KotlinLib";
import { BaseShader } from "webgl-framework";
import { ShaderInputs } from "./ShaderInputs";

export class ColorAnimatedTextureChunkedShader extends BaseShader implements ShaderInputs {
  public attributes?: number[];
  public typedAttributes?: { [key: number]: number };
  public uniforms?: WebGLUniformLocation[];

  fillCode() {
    this.vertexShaderCode = `#version 300 es
            precision highp float;
            uniform sampler2D sPositions;
            // x = texture width; y = texel half width; z = sampler y coord (animation frame); w = chunk size
            uniform vec4 uTexelSizes;
            uniform float uTexelHeight; // TODO: use precalculated texelHeight fractions
            uniform int uTextureWidthInt;
            uniform mat4 view_proj_matrix;

            vec2 getCenter2(vec2 y) {
              return y - mod(y, vec2(uTexelHeight)) + uTexelHeight * 0.5;
            }

            vec4 linearFilter(vec2 coords) {
              vec2 coords1 = vec2(coords.x, coords.y - uTexelHeight * 0.499);
              vec2 coords2 = vec2(coords.x, coords.y + uTexelHeight * 0.499);
              vec2 centers = getCenter2(vec2(coords1.y, coords2.y));
              vec4 v1 = texture(sPositions, vec2(coords1.x, centers.x));
              vec4 v2 = texture(sPositions, vec2(coords2.x, centers.y));
              vec2 d = abs(vec2(coords.y) - centers);
              if (d.x > d.y) {
                return mix( v1, v2, d.x / (uTexelHeight) );
              } else {
                return mix( v2, v1, d.y / (uTexelHeight) );
              }
            }

            void main() {
              float id = float(gl_VertexID % uTextureWidthInt);
              float chunk = float(gl_VertexID / uTextureWidthInt);
              vec2 coords = vec2(id / uTexelSizes.x + uTexelSizes.y, uTexelSizes.z);
              coords.y += chunk * uTexelSizes.w;
              vec4 position = linearFilter(coords);
              position.w = 1.0;
              gl_Position = view_proj_matrix * position;
            }`;

    this.fragmentShaderCode = `#version 300 es
            precision mediump float;
            uniform vec4 color;
            out vec4 fragColor;

            void main() {
              fragColor = color;
            }`;
  }

  fillUniformsAttributes() {
    const view_proj_matrix = this.getUniform("view_proj_matrix");
    const color = this.getUniform("color");
    const uTextureWidthInt = this.getUniform("uTextureWidthInt");
    const uTexelHeight = this.getUniform("uTexelHeight");
    const sPositions = this.getUniform("sPositions");
    const uTexelSizes = this.getUniform("uTexelSizes");

    this.attributes = [];
    this.typedAttributes = {};
    this.uniforms = [
      view_proj_matrix!,
      color!,
      uTextureWidthInt,
      uTexelHeight,
      sPositions,
      uTexelSizes
    ];
  }
}
